"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkDevice = exports.checkUserAgent = void 0;
const checkUserAgent = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes("macintosh")) {
        if (!userAgent.includes("chrome")) {
            return "mac safari";
        }
        else {
            return "mac chrome";
        }
    }
    if (userAgent.includes("windows")) {
        return "windows";
    }
    if (userAgent.includes("android")) {
        return "android";
    }
    if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
        return "ios";
    }
};
exports.checkUserAgent = checkUserAgent;
const checkDevice = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
        return "mobile";
    }
    return "web";
};
exports.checkDevice = checkDevice;
